export const OPEN_MODAL = 'containers/InvoiceCustomizeModal/OPEN_MODAL';
export const CLOSE_MODAL = 'containers/InvoiceCustomizeModal/CLOSE_MODAL';
export const MODAL_SUBMIT = 'containers/InvoiceCustomizeModal/MODAL_SUBMIT';

export const SHOW_LOADING_FULL_SCREEN = 'containers/InvoiceCustomizeModal/SHOW_LOADING_FULL_SCREEN';
export const HIDE_LOADING_FULL_SCREEN = 'containers/InvoiceCustomizeModal/HIDE_LOADING_FULL_SCREEN';
